import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { timeSince } from 'src/utils/date'
import { useSelector } from 'store/redux.store'
import { TItem } from './notification.types'
import { useNotification } from './notification.service'
import { getNameInitial } from './initialsTreatment'
import NotificationImagePlaceholder from './notification-image-placeholder.component'

const MenuNotificationItem = ({ tabIndex, ...notification }: TItem) => {
  const { t } = useTranslation()
  const { name: userName, cluster = { clusterInitials: '' } } = useSelector(state => state.user)
  const history = useHistory()
  const { put, post } = useNotification()
  const params = JSON.parse(notification.parameters)

  const nameInitial = getNameInitial({
    userName,
    type: notification.type,
    subtype: notification.subtype,
    parameters: notification.parameters
  })

  function onClick() {
    put.updateItem(notification.ucode)
    post.handleItemMetrics({
      ucode: notification.ucode,
      type: notification.type,
      subtype: notification.subtype,
      label: notification.label,
      cluster: cluster.clusterInitials
    })
    if (notification.uri.indexOf('http://') === 0 || notification.uri.indexOf('https://') === 0) {
      window.open(notification.uri)
      return null
    }
    history.push(notification.uri)
    return null
  }
  const { key, value } = timeSince(notification.timestamp)

  const pluralSufix = value > 1 ? '_plural' : ''

  return (
    <hot-dropdown-menu-item slot="menu" class="header-notification__item" onClick={onClick} tabIndex={tabIndex}>
      <div className="header-notification__item--icon">
        {notification.img ? (
          <img src={notification.img} alt="" width={48} height={48} />
        ) : (
          <NotificationImagePlaceholder nameInitial={nameInitial} type={notification.type} />
        )}
        {!notification.read && <span className="unread" />}
      </div>
      <section>
        <p className="_mb-0">
          <Trans
            i18nKey={`notifications.messages.${notification.label}`}
            values={{ productName: params?.productName }}
          />
        </p>
        <span className="header-notification__item--timestamp">
          {t(`general.time_from_now.${key}${pluralSufix}`, { value })}
        </span>
      </section>
    </hot-dropdown-menu-item>
  )
}

export default MenuNotificationItem
